import config from './config';

declare var __webpack_public_path__: string;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
__webpack_public_path__ = config.publicPath;
